import { skipToken } from '@reduxjs/toolkit/query';
import type { SubscriptionItemResponseDto } from '@tiendanube/common';
import {
  useCancelCustomerSubscriptionMutation,
  useGetCustomerSubscriptionsQuery,
} from 'domains/Customers/Customers/CustomerSubscriptions/subscriptionsApi';

export type UseCustomerSubscriptionsResult = Readonly<{
  subscriptions: ReadonlyArray<SubscriptionItemResponseDto>;
  isLoading: boolean;
  isError: boolean;
  refetch: () => Promise<any>;
  cancelSubscription: ReturnType<
    typeof useCancelCustomerSubscriptionMutation
  >[0];
  isCancelling: boolean;
  isCancelError: boolean;
}>;

function useCustomerSubscriptions(
  customerId: string,
): UseCustomerSubscriptionsResult {
  const { data, isLoading, isFetching, isError, refetch } =
    useGetCustomerSubscriptionsQuery(customerId ? { customerId } : skipToken);
  const [
    cancelSubscription,
    { isLoading: isCancelling, isError: isCancelError },
  ] = useCancelCustomerSubscriptionMutation();

  const subscriptions = data?.items ?? [];
  const loading = isLoading || isFetching;

  return {
    subscriptions,
    isLoading: loading,
    isError,
    refetch,
    cancelSubscription,
    isCancelling,
    isCancelError,
  };
}

export default useCustomerSubscriptions;
